
if (('Cookies' in window) && !!Cookies.get('TESCookieUser')) {
  document.documentElement.className += " tes-user-loggedin";
} else {
  document.documentElement.className += " tes-user-loggedout";
}
